import React from "react";

import background from "@cover/smombiesstoppen/background-1.jpg";
import backgroundSm from "@cover/smombiesstoppen/background-1-sm.jpg";
import SmombiesStoppen from "../components/cover/animations/smombiesstoppen";

export const meta = {
  category: "stop",
  slug: "smombies",
  id: "SmombiesStoppen",
  excerpt: {
    before:
      "Tanja (42) ist die Mutter von Maximilian (12). Was den Umgang mit digitalen Medien betrifft, darüber sind sich die beiden oft nicht einig. Auch der Kurzfilmwettbewerb der Stiftung Kinderland SMART. OHNE PHONE hat den Gebrauch von Handy & Co in der Familie aufgegriffen.",
  },
  name: "smombiesstoppen",
  title: "Meine analoge, deine digitale Welt",
  animation: SmombiesStoppen,
  cover: {
    background: {
      lg: background,
      sm: backgroundSm,
    },
    alt: "Maximilian und seine Mutter Tanja stehen sich gegenüber. Zwischen Ihnen liegt ein Turm aus Minecraft-Steinen, auf dem ein Doppelherz thront. Über ihren Köpfen sind jeweils Chatverläufe zu sehen: Einer, in dem Maximilians Freunde ihn zum Zocken einladen; einer, in dem Tanja ihm verbietet länger online zu sein, um an die frische Luft zu gehen.",
  },
};

const SmombiesstoppenArticle = () => {
  return (
    <div>
      <p className="articleParagraph">
        Tanja (42) ist die Mutter von Maximilian (12). Sie ist selbstständige
        Grafik-Designerin in Stuttgart und arbeitet von zu Hause aus. Maximilian
        geht in die 6. Klasse eines Gymnasiums. Seit der Pandemie ist er selten
        in der Schule. Auch weil der Unterricht online stattfindet, verbringt er
        seine Zeit häufig vor dem Rechner – zum Unmut seiner Mutter.
      </p>
      <p className="articleParagraph">
				Die ist als Kind immer gleich nach der Schule aufs Fahrrad gestiegen
        und erst Stunden später nach Hause zurückgekehrt. Maximilian kann sich
        auch stundenlang in Landschaften verlieren, die baut er aber an seinem
        Computer virtuell zusammen.
      </p>
      <p className="articleParagraph">
        Analoge versus digitale Welt. Wie blickt Tanja auf das Leben von
        Maximilian und Maximilian auf sein Eigenes? In den getrennten Gesprächen
        mit Mutter und Sohn blitzen nicht nur Unterschiede, sondern auch viele
        Gemeinsamkeiten heraus.
      </p>
      <p className="articleDialogue articleDialogue--left">
        <b>Das sagt die Mutter</b>
        Es ist schwer zu sagen, wie es meinem Sohn zurzeit geht. Jungs verbergen
        ihre Emotionen immer ein bisschen, zumindest ist das bei Maxi so und bei
        den Jungs seines Alters, die ich kenne. Die Situation belastet ihn,
        glaube ich, doch ganz schön. Auch wenn er das nicht so ausspricht. Ich
        merke, dass er übellaunig ist. Die Zeit mit Freunden, die Schule, das
        fehlt alles. Ich habe Angst, dass sich Maxi zu sehr einigelt und diese
        wahren und echten Kontakte verlernt oder nicht mehr schätzt. Und dass
        die Pandemie, dramatisch formuliert, seiner sozialen Entwicklung
        schadet.
      </p>
      <p className="articleDialogue articleDialogue--right">
        <b>Das sagt ihr Sohn Maximilian</b>
        Natürlich geht es mir mit Corona nicht besonders gut, ohne wäre
        natürlich besser. Es ist auch blöd, wenn man seine Freunde nicht treffen
        kann. Also nicht Eis essen gehen kann, was jetzt ja eigentlich ganz gut
        wäre. Oder im Park Fußball spielen. Und Präsenzunterricht finde ich
        eigentlich auch besser als Online-Unterricht. Zum einen sieht man seinen
        Lehrer, seine Freunde und Klassenkameraden. Zum anderen kann der Lehrer
        meistens besser erklären und man kann auch besser nachfragen.
      </p>
      <p className="articleDialogue articleDialogue--left">
        <b>Mutter</b>
        In seiner Freizeit, da zockt er. Minecraft ist ein großes Thema. Da
        trifft er sich mit Freunden in einer virtuellen Landschaft. Maxi spielt
        auch gern an der Konsole mit meinem Mann, meist Autorennen. Wie viel
        Zeit er am Rechner, Smartphone oder Tablett verbringt, hängt auch vom
        Wetter ab. Über den Winter fand ich die Dauer schon extrem und es hat
        deshalb viel Ärger bei uns zu Hause gegeben. Da wusste er schlicht
        nichts mit sich anzufangen, außer eben zu zocken.
      </p>
      <p className="articleDialogue articleDialogue--right">
        <b>Sohn</b>
        In Corona-Zeiten gehts ja schlecht, sich zu treffen. Ich spiele
        eigentlich recht viel, auch teilweise an der Spielekonsole Xbox, aber so
        generell spiele ich am meisten das Computerspiel Minecraft. Das ist so
        wie Lego bauen. Ich mag es, dass man da so viel machen kann. Man kann
        Landschaften bauen, allein oder mit Anderen, und wenn man Lust hat, kann
        man gegeneinander antreten und in der Landschaft kämpfen. Am meisten
        chatte ich mit meinen Freunden über WhatsApp.
      </p>
      <p className="articleDialogue articleDialogue--left">
        <b>Mutter</b>
        Es ist so: Maxi ist von 8.10 Uhr bis ungefähr 13 Uhr im
        Online-Unterricht. Zwar nicht durchgängig, er löst auch Aufgaben auf dem
        Blatt, aber trotzdem ist er durch den Unterricht an den Computer
        gebunden. Das ist also schon ein halber Arbeitstag. Und dann kommen drei
        Mal nachmittags jeweils zwei Stunden Online-Unterricht dazu. Und in der
        Freizeit zusätzlich Spielen und Chatten. Wir haben jetzt Zeit-Limits
        eingerichtet. Maxi kann für mehr Bildschirmzeit eine Anfrage auf unsere
        Geräte schicken, die wir mit einem geheimen Code freigeben können – oder
        eben auch nicht.
      </p>
      <p className="articleDialogue articleDialogue--right">
        <b>Sohn</b>
        Ich verbringe so fünf bis sieben Stunden mit Online-Unterricht am Tag
        und dann spiele ich ein bis zwei Stunden am Computer. Das ist natürlich
        schon eine recht lange Zeit, die man sozusagen vom Tag verschwendet und
        die man auch irgendwie hätte draußen verbringen können. Aber theoretisch
        mache ich ja Unterricht. Meine Eltern haben eine Zeit definiert.
        Manchmal streiten wir uns deshalb. Wenn ich zum Beispiel mitten in einem
        Rennen bin oder gerade in Minecraft etwas baue und aufhören muss, das
        finde ich natürlich doof. Da verlange ich dann schon ein bisschen mehr
        Zeit für das Projekt, damit ich es zu Ende bringen kann. Teilweise kann
        ich länger spielen, aber teilweise auch nicht. Manchmal kann ich
        verstehen, dass sie das nicht erlauben.
      </p>
      <p className="articleDialogue articleDialogue--left">
        <b>Mutter</b>
        Zunächst haben wir auf den gesunden Menschenverstand gesetzt, dass er
        mit 12 Jahren gut einschätzen kann, wann es mit dem Spielen genug ist.
        Das war sehr naiv gedacht. Dann haben wir ihm eine Stunde Medienzeit am
        Tag eingeräumt. Da war dann alles drin: Computerspiele, Xbox oder Filme
        auf YouTube gucken. Das hat auch nicht funktioniert. Jetzt haben wir
        eine Mischung aus Kontrolle und Vertrauen. Wenn er mit seiner Nutzung
        eindeutig zu weit geht, wird gedrosselt. Das muss er dann einfach
        verstehen. Man wünscht sich eine Art Patentlösung, die man einmal
        einführt und dann läufts. Aber das ist halt nicht so.
      </p>
      <p className="articleDialogue articleDialogue--right">
        <b>Sohn</b>
        Meine Mutter und ich haben einmal ein Online-Spiel gespielt, aber dann
        nie wieder. Vielleicht macht es ihr keinen Spaß. So genau weiß ich das
        nicht. Meine Mutter sagt häufiger, dass ich weniger spielen soll, mein
        Vater sagt nicht so viel dazu. Der findet das ganz okay. Mein Vater
        steckt den ganzen Tag in Telefonkonferenzen und spielt manchmal auf der
        Xbox, wenn ich im Bett bin. Meine Mutter guckt Netflix und macht
        Instagram.
      </p>
      <p className="articleDialogue articleDialogue--left">
        <b>Mutter</b>
        Ich muss gestehen, dass mir diese ganze Entwicklung Sorgen macht. Mein
        Mann ist seit einem Jahr im Homeoffice. Er sitzt drüben im
        Wohn-Esszimmer, ich meistens im Schlafzimmer oder in der Küche, unser
        Sohn und unsere Tochter in ihren Zimmern und jeder daddelt vor sich hin.
        Und wenn man aus Bequemlichkeit aus dem anderen Zimmer eine SMS
        schreibt, das geht mir einfach zu weit. Gleichzeitig wird das ständige
        Online-Sein und über Geräte kommunizieren immer selbstverständlicher.
        Ich finde das sehr schade, weil man die Familienzeit auch anders
        verbringen kann.
      </p>
      <p className="articleDialogue articleDialogue--right">
        <b>Sohn</b>
        Ich finde es jetzt natürlich schon besser, wenn mein Vater wie jetzt von
        zu Hause arbeitet und ich ihn immer sehe. Wenn wir alle zusammen zu
        Mittag essen und meine Schwester nicht in der Schule ist und wir
        miteinander spielen können, das finde ich gut.
      </p>
      <p className="articleDialogue articleDialogue--left">
        <b>Mutter</b>
        Ich predige den Kindern auch permanent, dass man die echten, wahren
        Kontakte den Chats immer vorziehen muss. Oder eine Radtour mit einem
        Freund viel besser ist, anstatt hier zu Hause zu sitzen und zu zocken.
        Maxi nimmt meinen Rat zwar an, setzt ihn aber nicht immer um. Und dann
        muss ich ihn wieder ermahnen. Ich fühle mich dabei manchmal wie eine
        Schallplatte, die immer wieder das Gleiche abspielt. Was ich mir aber
        auch eingestehen muss: Ich darf nicht meine Kindheit mit der Kindheit
        meiner Kinder vergleichen. Die wachsen mit diesen ganzen digitalen
        Themen auf. Das ist normal, es gehört dazu. Ich hab da so diese
        romantische Vorstellung von früher. Nach der Schule fuhr ich schnell
        nach Hause, kurz Mittagessen, dann Hausaufgaben und ab aufs Rad. Wir
        sind erst nach Hause gekommen, wenn die Laternen angegangen sind. Man
        muss als Eltern umdenken und akzeptieren lernen, dass es heute anders
        ist.
      </p>
      <p className="articleDialogue articleDialogue--right">
        <b>Sohn</b>
        Wenn ich die Wahl zwischen WhatsApp und Minecraft hätte, würde ich
        WhatsApp nehmen. Weil ich dann wenigstens mit Freunden Kontakt haben
        kann. Und wenn ich eine Woche auf alles verzichten müsste, dann würde
        ich auf jeden Fall viel mehr draußen sein. Ich bin jetzt sowieso viel
        lieber draußen als im Winter. Ich klettere gern auf Bäumen, das macht
        mir Spaß.
      </p>
    </div>
  );
};

export default SmombiesstoppenArticle;
